import React from 'react';
import { DivideIcon as LucideIcon } from 'lucide-react';

interface FeatureCardProps {
  icon: LucideIcon;
  title: string;
  description: string;
}

const FeatureCard: React.FC<FeatureCardProps> = ({ icon: Icon, title, description }) => {
  return (
    <div className="card hover:translate-y-[-5px] group">
      <div 
        className="mb-4 text-primary-light group-hover:text-primary transition-colors p-3 inline-flex rounded-full bg-primary bg-opacity-10"
        aria-hidden="true"
      >
        <Icon size={32} />
      </div>
      <h3 className="text-xl font-semibold mb-2">{title}</h3>
      <p className="text-gray-600">{description}</p>
    </div>
  );
};

export default FeatureCard;